module.exports = __webpack_public_path__ + "media/images/growth-color-icon-bb0b54252a282ee636d86c88dcfb7a58.png";